export const CUSTOMERS_PATH = '/customers'
export const LOGIN_PATH = '/'
export const INBOX_PATH = '/inbox'
export const SEARCH_PATH = '/search'
export const DASHBOARD_PATH = '/dashboard'
export const ACCOUNTING_PATH = '/accounting'
export const ROLLING_CREDIT = '/rolling-credit'
export const SPEND_CONTROLS = '/spend-controls'
export const TEMPLATE_DETAILS_PATH = '/subscription/:templateId'
export const SUBSCRIPTION_PATH = '/subscription'
export const AUTH_PERSON_PATH = '/authperson/:authPersonId'
export const FRAUD_CASES_PATH = '/fraud-cases'

export default {
  LOGIN_PATH,
  CUSTOMERS_PATH,
  INBOX_PATH,
  SEARCH_PATH,
  DASHBOARD_PATH,
  ACCOUNTING_PATH,
  ROLLING_CREDIT,
  SPEND_CONTROLS,
  TEMPLATE_DETAILS_PATH,
  SUBSCRIPTION_PATH,
  AUTH_PERSON_PATH,
  FRAUD_CASES_PATH,
}
